import { SELECT_SIZE, SIZING_KIT } from '@/app/[locale]/product/_consts';
import type CurrentRouteValues from '@/app/[locale]/product/_hooks/useCurrentRoute/types';
import type { GetStyleStockStatus } from '@/app/[locale]/product/_hooks/useProductsInventory';
import { ACCESSORIES_ROOT_PATH, POP_PATHNAME } from '@/app/consts/pathnames';
import { RingModelEnum } from '@/app/enums/RingModelEnum';
import { type RingStyleEnum } from '@/app/enums/RingStyleEnum';
import type { RingFinish } from '@/app/types/ring';

import WizStepId from '../enums/WizStepId';

interface GetHref {
  currentRoute: CurrentRouteValues | undefined;
  currentStep: WizStepId | undefined;
  getFirstStockedFinish: (props: GetStyleStockStatus) => RingFinish;
  isOuraRing4Wizard: boolean;
}

export const getHref = ({
  currentRoute,
  currentStep,
  getFirstStockedFinish,
  isOuraRing4Wizard,
}: GetHref): string => {
  if (!currentRoute) return POP_PATHNAME;
  const accessory = currentRoute.accessory;
  const style = currentRoute.style;
  const finish = currentRoute.finish;
  const stockedFinish = getFirstStockedFinish({
    isOuraRing4: isOuraRing4Wizard,
    style: style.value as RingStyleEnum,
  });
  const size = currentRoute.size;
  const href = isOuraRing4Wizard
    ? [POP_PATHNAME, RingModelEnum.Oura4]
    : [POP_PATHNAME, RingModelEnum.Gen3, style.value];

  switch (currentStep) {
    case WizStepId.Accessory:
      return `${ACCESSORIES_ROOT_PATH}/${accessory.value}/${SELECT_SIZE}`;
    case WizStepId.Style:
      href.push(finish.value.length ? finish.value : stockedFinish);
      break;
    case WizStepId.Finish:
      href.push(finish.value.length ? finish.value : stockedFinish);
      href.push(size.value.length ? size.value : SIZING_KIT);
      break;
    case WizStepId.Size:
      href.push(finish.value);
      href.push(size.value);
      break;
  }

  return href.join('/');
};
